import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const NichesEdit = props => (
  <Edit {...props} resource="niches">
    <Form />
  </Edit>
);

NichesEdit.propTypes = {};

export default NichesEdit;
